const TOKEN_KEY = 'ac_admin_token'
const ADMIN_KEY = 'ac_admin_user'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getAdmin() {
  const raw = localStorage.getItem(ADMIN_KEY)
  return raw ? JSON.parse(raw) : null
}

export function setAdmin(admin) {
  localStorage.setItem(ADMIN_KEY, JSON.stringify(admin))
}

export function removeAdmin() {
  localStorage.removeItem(ADMIN_KEY)
}

export function clearAuth() {
  removeToken()
  removeAdmin()
}

export function formatMoney(val) {
  const n = Number(val)
  if (Number.isNaN(n)) return '0.00'
  return n.toFixed(2)
}

export function formatDateTime(str) {
  if (!str) return '-'
  return str.replace('T', ' ').slice(0, 19)
}

export const ORDER_STATUS = {
  pending: { label: '待支付', type: 'warning' },
  paid: { label: '已支付', type: 'primary' },
  completed: { label: '已完成', type: 'success' },
  cancelled: { label: '已取消', type: 'info' }
}

export const USER_STATUS = {
  active: { label: '正常', type: 'success' },
  disabled: { label: '禁用', type: 'danger' }
}

export function getOrderStatus(status) {
  return ORDER_STATUS[status] || { label: status || '未知', type: 'info' }
}

export function getUserStatus(status) {
  return USER_STATUS[status] || { label: status || '未知', type: 'info' }
}

export function formatStatMoney(val) {
  const n = Number(val)
  if (Number.isNaN(n)) return '0'
  return n.toLocaleString()
}
